module.exports = ".logo {\n  height: 50px; }\n\n@media (max-width: 991px) {\n  .navbar {\n    padding: 1.3rem 2rem; }\n  .logo {\n    height: 40px; } }\n\n@media (max-width: 770px) {\n  .navbar {\n    padding: 0rem 2rem; }\n  .logo {\n    height: 40px; } }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/component/app-header/lbpa-app-header.component.scss
// module id = gBq3
// module chunks = 1